import { ARSTActionSetSidebarView, ArsTableState } from "../interface";

/**
 * Updates the active sidebar view.
 *
 * @param state - Current ARS table state
 * @param action - Sidebar view update action
 * @returns Updated ARS table state
 */
export const arst_setSidebarView = <T>(
  state: ArsTableState<T>,
  action: ARSTActionSetSidebarView,
): ArsTableState<T> => ({
  ...state,
  settings: {
    ...state.settings,
    currentSidebar: {
      ...state.settings.currentSidebar,
      view: action.view,
    },
  },
});
